import { useContext } from 'react'

import { Box, Spinner } from '@fairfashion/design-system'

import { BackButton } from '../../components/BackButton/back-button.comp'
import { ProviderMap } from '../../components/ProviderMap/provider-map.comp'

import { ProviderCertificatesCard } from './components/ProviderCertificatesCard/provider-certificates-card.comp'
import { ProviderInfo } from './components/ProviderInfo/provider-info.comp'
import { ProviderResumeCards } from './components/ProviderResumeCards/provider-resume-cards.comp'
import { ProviderRisksCard } from './components/ProviderRisksCard/provider-risks-card.comp'
import { ProviderTabs } from './components/ProviderTabs/provider-tabs.comp'
import { ProviderContext, ProviderProvider } from './provider.context'

const ProviderComp = () => {
  const { loading, data } = useContext(ProviderContext)

  return !loading ? (
    <Box width="100%" direction="column" gap={3} padding={3}>
      <Box alignItems="center" gap={2}>
        <BackButton url="/providers/" />
      </Box>
      {data ? (
        <>
          <Box
            width="100%"
            height="100%"
            gap={3}
            flexWrap="wrap"
            alignItems="stretch"
          >
            <Box
              flex={1}
              direction="column"
              gap={3}
              maxWidth="460px"
              width="100%"
            >
              <Box
                width="100%"
                flex={1}
                flexWrap="wrap"
                alignItems="stretch"
                gap={3}
              >
                <ProviderInfo />
              </Box>
              <ProviderResumeCards />
            </Box>
            <Box flex={1} flexWrap="wrap" gap={3} direction="column">
              <Box width="100%" gap={3} alignItems="stretch" flexWrap="wrap">
                <ProviderRisksCard />
                <ProviderCertificatesCard />
              </Box>
              <ProviderMap company={data} />
            </Box>
          </Box>
          <ProviderTabs />
        </>
      ) : (
        <Box
          width="100%"
          height="50vh"
          alignItems="center"
          justifyContent="center"
        >
          Não há dados para esse fornecedor
        </Box>
      )}
    </Box>
  ) : (
    <Box
      width="100%"
      height="100%"
      padding={3}
      alignItems="center"
      justifyContent="center"
    >
      <Spinner size="40px" />
    </Box>
  )
}

export const Provider = () => {
  return (
    <ProviderProvider>
      <ProviderComp />
    </ProviderProvider>
  )
}
